import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["country", "city", "selectContainer", "inputContainer", "cityInput"]

  connect() {
    console.log("City Selector: Controller connected")
    if (this.countryTarget.value) {
      this.updateCities()
    }
  }

  toggleManual(event) {
    if (event) event.preventDefault()
    console.log("City Selector: Toggling manual entry")
    
    const isManual = this.selectContainerTarget.classList.contains('hidden')
    
    if (isManual) {
      // Switch back to select
      this.selectContainerTarget.classList.remove('hidden')
      this.inputContainerTarget.classList.add('hidden')
      this.cityTarget.disabled = false
      this.cityInputTarget.disabled = true
      if (event) event.currentTarget.innerText = "Can't find your city?"
    } else {
      // Switch to manual input
      this.selectContainerTarget.classList.add('hidden')
      this.inputContainerTarget.classList.remove('hidden')
      this.cityTarget.disabled = true
      this.cityInputTarget.disabled = false
      if (event) event.currentTarget.innerText = "Switch back to list"
    }
  }

  // This is called when a city is picked from the dropdown
  cityChanged() {
    const country = this.countryTarget.value
    const city = this.cityTarget.value
    console.log(`City Selector: City dropdown changed to "${city}, ${country}"`)
    
    if (city && country) {
      // Dispatch an event so the map controller can listen and move the map
      this.dispatch("city-selected", { detail: { country, city } })
    }
  }

  // This is called when a user types a city manually
  manualCityChanged() {
    const country = this.countryTarget.value
    const city = this.cityInputTarget.value
    console.log(`City Selector: Manual city changed to "${city}, ${country}"`)
    
    if (city && country && city.length > 2) {
      this.dispatch("city-selected", { detail: { country, city } })
    }
  }

  async updateCities() {
    const country = this.countryTarget.value
    console.log(`City Selector: Selected country is "${country}"`)

    if (!country) {
      this.cityTarget.innerHTML = '<option value="">Select a country first</option>'
      return
    }

    // Capture current city to re-select it if possible
    const currentCity = this.cityTarget.getAttribute('data-current-city') || this.cityTarget.value
    
    this.cityTarget.innerHTML = '<option value="">Loading cities...</option>'
    this.cityTarget.disabled = true

    try {
      console.log(`City Selector: Fetching cities from API for ${country}...`)
      
      const response = await fetch('https://countriesnow.space/api/v0.1/countries/cities', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ country: country })
      })
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const result = await response.json()
      console.log("City Selector: API result received", result)

      if (!result.error && result.data && result.data.length > 0) {
        this.cityTarget.innerHTML = '<option value="">Select a city</option>'
        
        // Sort cities alphabetically
        const sortedCities = result.data.sort()
        
        sortedCities.forEach(city => {
          const option = document.createElement("option")
          option.value = city
          option.text = city
          if (city === currentCity) option.selected = true
          this.cityTarget.appendChild(option)
        })
        console.log(`City Selector: Populated ${sortedCities.length} cities`)
      } else {
        console.warn(`City Selector: No cities found for ${country}`)
        this.cityTarget.innerHTML = '<option value="">No cities found for this country</option>'
        
        // If we have a current city, at least show that
        if (currentCity) {
          const option = document.createElement("option")
          option.value = currentCity
          option.text = currentCity
          option.selected = true
          this.cityTarget.appendChild(option)
        }
      }
    } catch (error) {
      console.error("City Selector: Error fetching cities:", error)
      this.cityTarget.innerHTML = '<option value="">Error loading cities</option>'
      
      if (currentCity) {
        const option = document.createElement("option")
        option.value = currentCity
        option.text = currentCity
        option.selected = true
        this.cityTarget.appendChild(option)
      }
    } finally {
      this.cityTarget.disabled = false
    }
  }
}
